export const useChangedCellStyles = () => {
  return {
    changedCell: {
      display: 'flex',
      flexDirection: 'column',
    },
    oldValue: {
      color: 'rgba(0, 0, 0, 0.87)',
      fontWeight: 400,
    },
    newValue: {
      color: '#05A4D8',
      display: 'flex',
      alignItems: 'center',
    },
  };
};
